import Cookies from 'js-cookie';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { CookieEnum } from '../../enums/cookie-enum';
import { useGetMeQuery } from '../../store/apiSlice/userApi';
import { Loading } from '../shared/loader/Loader';

const VerifiedProfileRoute = () => {
  const location = useLocation();
  const token = Cookies.get(CookieEnum.ACCESS_TOKEN);

  const bypassVerifiedCheck =
    location.pathname === '/subscription-plans' ||
    location.pathname === '/subscription-payment' ||
    location.pathname === '/subscription-successfully-paid' ||
    location.pathname === '/company-questionnaire';

  // Use /me endpoint for auth guard (doesn't require userId)
  const { data: userData, isLoading: isUserDataLoading } = useGetMeQuery([], {
    skip: !token || bypassVerifiedCheck,
  });
  // for now not required
  // const { data: companyData, isLoading: isCompanyDataLoading } =
  //   useGetUserCompanyInfoQuery(undefined, {
  //     skip: role !== UserRoleEnum.COMPANY,
  //   });

  const isAccountVerified = userData?.verified;

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (bypassVerifiedCheck) {
    return <Outlet />;
  }

  if (isUserDataLoading) {
    return <Loading />;
  }
  // explicit type assertion, we check only loaded data and verified field must be present!
  if (isAccountVerified === false) {
    return (
      <Navigate
        to="/profile"
        replace
        state={{ showUnverifiedUserModal: true }}
      />
    );
  }

  return <Outlet />;
};

export default VerifiedProfileRoute;
